export default "__VITE_ASSET__ChDqjPSl__ 640w, __VITE_ASSET__CyXXUu8r__ 1024w, __VITE_ASSET__DxePMHtv__ 1672w";